// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"761":"5b166aeb82a143aa","1778":"cc3a08681f2bdd99","2553":"9b25cba27aea5cae","8208":"d90a0cbf6b584d12"}[chunkId] + ".js";
};